export default {
  title: 'Looks like you’re offline',
  description: 'Please click “Reload Page” and/ or check your internet connection to ensure you are online 😊',
  custom_button: {
    reload: 'Reload Page',
  },
};
